module.exports = __webpack_public_path__ + "img/旺旺大礼包.4da329cc.jpg";